import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { tarrytownConfig } from "./data";

export default function TarrytownPage() {
  return <CityPageTemplate config={tarrytownConfig} />;
}